
import React from "react"
import App from "./App.js"
import reactDOM from "react-dom"
import {createStore} from "redux"
import {Provider} from "react-redux"
import {initialState} from "./components/Products"

const Reducer=(state=initialState,action)=>{
    console.log(action);
    
    switch(action.type){ //using swicht 
        case "addtocart":
            let duplicateItem = state.cart.find(item => item.name === action.payload.name);
           console.log(duplicateItem)
           
            if(duplicateItem) {
                let index = state.cart.indexOf(duplicateItem);
                state.cart[index].item ++;
               return {...state, cart: state.cart} 
            } else{

                return {...state,cart:[...state.cart,{...action.payload,id:new Date().getTime().toString()}]}
            }
           
            case "deleteitem":
                return {...state,cart:state.cart.filter(item=>item.id!==action.payload.id)}
                case "updateItem":
                    return {...state,products:state.products.map(p=>p.id===action.payload?{...p,like:!p.like}:p)}
            
            default:
                return state
            
    }
}


const myStore = createStore(Reducer )
 

reactDOM.render( <Provider store={myStore}><App/></Provider>,document.getElementById("root"))